
<div class="d-flex justify-content-between mb-3" (click)="collapse2.toggle()" [attr.aria-expanded]="!isCollapsed2"
  aria-controls="collapseExample">
  <div>
    <span class="d-flex mb-1">
      <span class="mr-2">
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clip-path="url(#clip0_2016_81038)">
              <path d="M14.6667 2.84438L13.0223 1.19994C12.8809 1.06517 12.6931 0.98999 12.4978 0.98999C12.3025 0.98999 12.1147 1.06517 11.9734 1.19994L10.5112 2.6666H2.66672C2.43097 2.6666 2.20488 2.76025 2.03818 2.92695C1.87148 3.09365 1.77783 3.31975 1.77783 3.55549V13.3333C1.77783 13.569 1.87148 13.7951 2.03818 13.9618C2.20488 14.1285 2.43097 14.2222 2.66672 14.2222H12.4445C12.6802 14.2222 12.9063 14.1285 13.073 13.9618C13.2397 13.7951 13.3334 13.569 13.3334 13.3333V5.2266L14.6667 3.89327C14.8057 3.75411 14.8837 3.56549 14.8837 3.36883C14.8837 3.17217 14.8057 2.98354 14.6667 2.84438ZM8.36894 8.9466L6.50672 9.35994L6.95117 7.51549L11.1956 3.26216L12.6312 4.69772L8.36894 8.9466ZM13.1112 4.19105L11.6756 2.75549L12.4978 1.93327L13.9334 3.36883L13.1112 4.19105Z" fill="#484B59"/>
            </g>
            <defs>
              <clipPath id="clip0_2016_81038">
                <rect width="16" height="16" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </span>
        <span class="f-12 font-weight-600">
          Hiring Notes
        </span>
      </span>
    </span>
      <p class="f-12 font-weight-500 mb-0">
        Capture feedback, interview observations & hiring discussions
      </p>
  </div>
  @if (isCollapsed2) {
  <span class="pointer"><i class="fa-regular fa-angle-down"></i></span>
  } @else {
  <span class="pointer"><i class="fa-regular fa-angle-up"></i></span>
  }
</div>
<div class="mb-4" #collapse2="ngbCollapse" [(ngbCollapse)]="isCollapsed2">
  <div class="side-panel-card">
    @if(calledFrom == 'pipeline-list' || calledFrom == 'my-candidates') {
    <div class="notes-list">
      @for(nt of notes; track nt; let i = $index) {
        <div class="bb-1 pb-2">
          <div class="d-flex align-items-baseline mb-1">
            <span class="f-12 font-weight-600">{{nt?.firstname}} {{nt?.lastname}}</span>
            <span class="mx-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                <circle cx="2" cy="2" r="2" fill="#E6E5E5"/>
              </svg>
            </span>
            <span class="f-12 text-9696">
              {{nt?.createdon | date: 'dd MMM yyyy'}}
            </span>
                @if(nt?.isprivate == 0 || nt?.isprivate == 1 || (nt?.isprivate == 2 &&(isLoggedinUserIsAdmin || nt?.isactualcreator))){
           <div class="d-flex text-right ml-auto">

            <button data-testid="auto-app-hire-notes-button-1" class="btn-svg" (click)="editnotes(nt)">
             <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.73345 12.755H4.60429L10.5779 6.7814L9.70706 5.91057L3.73345 11.8842V12.755ZM2.51123 13.9772V11.38L10.5779 3.32862C10.7001 3.21659 10.8352 3.13001 10.9831 3.0689C11.131 3.00779 11.2862 2.97723 11.4487 2.97723C11.6113 2.97723 11.7692 3.00779 11.9223 3.0689C12.0755 3.13001 12.2079 3.22168 12.3196 3.3439L13.1598 4.19946C13.2821 4.31149 13.3713 4.4439 13.4275 4.59668C13.4837 4.74946 13.5116 4.90223 13.5112 5.05501C13.5112 5.21797 13.4833 5.3734 13.4275 5.52129C13.3717 5.66918 13.2825 5.80403 13.1598 5.92584L5.10845 13.9772H2.51123ZM10.1348 6.35362L9.70706 5.91057L10.5779 6.7814L10.1348 6.35362Z" fill="#5E5E5E"/>
</svg>

            </button>
               <button data-testid="auto-app-hire-notes-button-2" class="btn-svg" (click)="deletenotesmodal(nt)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M4.00016 12.6667C4.00016 13.4 4.60016 14 5.3335 14H10.6668C11.4002 14 12.0002 13.4 12.0002 12.6667V6C12.0002 5.26667 11.4002 4.66667 10.6668 4.66667H5.3335C4.60016 4.66667 4.00016 5.26667 4.00016 6V12.6667ZM6.00016 6H10.0002C10.3668 6 10.6668 6.3 10.6668 6.66667V12C10.6668 12.3667 10.3668 12.6667 10.0002 12.6667H6.00016C5.6335 12.6667 5.3335 12.3667 5.3335 12V6.66667C5.3335 6.3 5.6335 6 6.00016 6ZM10.3335 2.66667L9.86016 2.19333C9.74016 2.07333 9.56683 2 9.3935 2H6.60683C6.4335 2 6.26016 2.07333 6.14016 2.19333L5.66683 2.66667H4.00016C3.6335 2.66667 3.3335 2.96667 3.3335 3.33333C3.3335 3.7 3.6335 4 4.00016 4H12.0002C12.3668 4 12.6668 3.7 12.6668 3.33333C12.6668 2.96667 12.3668 2.66667 12.0002 2.66667H10.3335Z" fill="#5E5E5E"/>
              </svg>
            </button>
            </div>
          }
          </div>
           <!-- style="display: flex; word-wrap: anywhere;" -->
          <p class="text-9696 f-12 line-height-1 mb-0 text-wrap" [innerHtml]="nt?.note"></p>

        </div>

      }

        <div class="d-flex">
          <!-- <div>
            <input data-testid="auto-app-hire-notes-input-1" type="text" class="wc-form-control" placeholder="Write a Note...">
          </div> -->
          <button data-testid="auto-app-hire-notes-button-3" class="btn-trms-gray add-note" (click)="addNotes()">Add Notes</button>
        </div>
      </div>
    } @else{
        <div class="d-flex justify-content-center align-items-center flex-column" style="height: 200px;">
        <p class="text-center">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <g clip-path="url(#clip0_2016_82999)">
                <path d="M3.99984 14.6667C3.63317 14.6667 3.31939 14.5363 3.0585 14.2754C2.79761 14.0145 2.66695 13.7005 2.6665 13.3334V6.66675C2.6665 6.30008 2.79717 5.9863 3.0585 5.72542C3.31984 5.46453 3.63362 5.33386 3.99984 5.33342H4.6665V4.00008C4.6665 3.07786 4.99162 2.29186 5.64184 1.64208C6.29206 0.992304 7.07806 0.667193 7.99984 0.666749C8.92162 0.666304 9.70784 0.991415 10.3585 1.64208C11.0092 2.29275 11.3341 3.07875 11.3332 4.00008V5.33342H11.9998C12.3665 5.33342 12.6805 5.46408 12.9418 5.72542C13.2032 5.98675 13.3336 6.30053 13.3332 6.66675V13.3334C13.3332 13.7001 13.2027 14.0141 12.9418 14.2754C12.6809 14.5367 12.3669 14.6672 11.9998 14.6667H3.99984ZM3.99984 13.3334H11.9998V6.66675H3.99984V13.3334ZM8.94184 10.9414C9.20273 10.681 9.33317 10.3672 9.33317 10.0001C9.33317 9.63297 9.20273 9.31919 8.94184 9.05875C8.68095 8.7983 8.36695 8.66764 7.99984 8.66675C7.63273 8.66586 7.31895 8.79653 7.0585 9.05875C6.79806 9.32097 6.66739 9.63475 6.6665 10.0001C6.66562 10.3654 6.79628 10.6794 7.0585 10.9421C7.32073 11.2047 7.6345 11.3352 7.99984 11.3334C8.36517 11.3316 8.67917 11.2005 8.94184 10.9414ZM5.99984 5.33342H9.99984V4.00008C9.99984 3.44453 9.80539 2.9723 9.4165 2.58342C9.02762 2.19453 8.55539 2.00008 7.99984 2.00008C7.44428 2.00008 6.97206 2.19453 6.58317 2.58342C6.19428 2.9723 5.99984 3.44453 5.99984 4.00008V5.33342Z" fill="#484B59"/>
              </g>
              <defs>
                <clipPath id="clip0_2016_82999">
                  <rect width="16" height="16" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </span>
         <span class="f-12 font-weight-600">Add this candidate to a project</span>

         </p>
         <p class="f-12 text-9696 text-center">Notes and hiring feedback become available after adding this candidate to a project.</p>
    </div>

    }
  </div>
</div>
<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
